<template>
<div>
    <!-- BootstrapVue Done -->
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-dark">
    </base-header>
    <card>
        <div class="accordion" role="tablist">
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-1 variant="info" align="left"><b>MAKLUMAT PENJAWAT AWAM</b></b-button>
                </b-card-header>
                <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <b-card-text>
                            <!-- <b-container fluid class="mt--6"> -->
                            <!-- <card header-classes="bg-transparent"> -->
                            <h3 class="mb-0">Maklumat Penjawat Awam</h3>
                            <br />
                            <div class="pl-lg-4">
                                <b-row class="my-1">
                                    <b-col sm="3"> No Kad Pengenalan</b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="3">{{NoKP}}</b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"> Nama </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="3">{{NamaPeribadi}}</b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3">Klasifikasi Perkhidmatan Pertama </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="3">{{$store.state.MaklumatPeribadi.ServClassTitle}}</b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3">Skim Perkhidmatan </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="3">{{$store.state.MaklumatPeribadi.SchmOfServTitle}}</b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3">Gred Jawatan Lantikan Pertama </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="3">{{$store.state.MaklumatPeribadi.GredLantikan}}</b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3">Gaji Lantikan Pertama </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="3">{{$store.state.MaklumatPeribadi.SalGrdPertama}}</b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3">Tarikh Lantikan Pertama </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="3">{{$store.state.MaklumatPeribadi.TarikhLantikan}}</b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3">Tarikh Dijangka Bersara </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="3">{{$store.state.MaklumatPeribadi.TarikhJangkaBersara}}</b-col>
                                </b-row>
                                <b-row class="my-1" v-if="$store.state.MaklumatPeribadi.StatusKGT2023==1">
                                    <b-col sm="3">Layak Menerima KGT Khas 2023 </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="3">{{StatusKGT2023Papar}}</b-col>
                                </b-row>
                                <b-row class="my-1" v-if="$store.state.MaklumatPeribadi.MeninggalDunia==1">
                                    <b-col sm="3">Tarikh Meninggal Dunia </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="3">{{$store.state.MaklumatPeribadi.DtMeninggalDunia}}</b-col>
                                </b-row>
                                <br>
                                <b-row>
                                    <b-col>
                                        <b-button size="md" variant="primary" @click="ToPageMaklumatperibadi()">KEMASKINI MAKLUMAT</b-button>
                                    </b-col>
                                </b-row>
                            </div>
                            <!-- </card> -->
                            <!-- </b-container> -->

                        </b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-2 variant="info"><b>STATUS MAKLUMAT PEGAWAI LANTIKAN SEBELUM 2003</b></b-button>
                </b-card-header>
                <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <b-card-text>

                            <div v-if="this.activeMakl2003==1">
                                <!-- <b-container fluid class="mt--6">
                                    <card header-classes="bg-transparent"> -->
                                <h3 class="mb-0">STATUS MAKLUMAT PEGAWAI LANTIKAN SEBELUM 2003</h3>
                                <br />
                                <div class="pl-lg-4">
                                    <b-row class="my-1">
                                        <b-col sm="5"> Gaji pada 31.12.2002 </b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="3">{{$store.state.MaklPegSeb2003.Sal2002}}</b-col>
                                    </b-row>
                                    <b-row class="my-1">
                                        <b-col sm="5">Klasifikasi Perkhidmatan pada 31.12.2002 </b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="3">{{ServClassList.ServClassTitle}}</b-col>
                                    </b-row>
                                    <b-row class="my-1">
                                        <b-col sm="5">Skim Perkhidmatan pada 31.12.2002 </b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="3">{{SchmOfServList.SchmOfServTitle}}</b-col>
                                    </b-row>
                                    <b-row class="my-1">
                                        <b-col sm="5">Gred Jawatan pada 31.12.2002 </b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="3">{{SalGrdList.SalGrd}}</b-col>
                                    </b-row>
                                    <b-row class="my-1">
                                        <b-col sm="5"> Tarikh Pergerakan Gaji (TPG) pada 31.12.2002 </b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="3">{{$store.state.MaklPegSeb2003.DtTPG2002}}</b-col>
                                    </b-row>
                                    <br />
                                    <b-button size="md" variant="primary" @click="ToPageLantikan2003()">KEMASKINI MAKLUMAT</b-button>
                                </div>
                                <!-- </card>
                                </b-container> -->
                            </div>
                            <div v-if="this.activeMakl2003==0">
                                <!-- <b-container fluid class="mt--6">
                                    <card header-classes="bg-transparent"> -->
                                <!-- <h3 class="mb-0">STATUS MAKLUMAT PEGAWAI LANTIKAN SEBELUM 2003</h3> -->
                                <br />
                                <div class="pl-lg-4">
                                    <b-row class="my-1">
                                        <b-col sm="5"> TIADA MAKLUMAT </b-col>
                                    </b-row>
                                    <b-button size="md" variant="primary" @click="ToPageLantikan2003()">KEMASKINI MAKLUMAT</b-button>
                                </div>
                                <!-- </card>
                                </b-container> -->
                            </div>

                        </b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-3 variant="info"><b>STATUS TIADA PERGERAKAN GAJI TAHUNAN</b></b-button>
                </b-card-header>
                <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <b-card-text>
                            <h3 class="mb-0">STATUS TIADA PERGERAKAN GAJI TAHUNAN</h3>
                            <br />
                            <div class="pl-lg-4">
                                <b-card-header class="border-0">
                                    <h3 class="mb-0">TAHUN TIDAK MENERIMA PGT</h3>
                                </b-card-header>
                                <el-table class="table-responsive table" header-row-class-name="thead-light" :header-cell-style="{background:'#f6f9fc',color:'#8898aa'}" :data="objthnTdkPGT" style="width: 100%">
                                    <el-table-column align="center" type="index" width="100px">
                                    </el-table-column>

                                    <el-table-column label="TAHUN" prop="YearID" min-width="200px" align="center">
                                    </el-table-column>

                                    <el-table-column label="Tindakan" min-width="150px" align="center">
                                        <template slot="header">
                                            <div style="width:100%;text-align:center">
                                                <base-button v-if="true" size="sm" icon type="success" class="mb-2" style="font-size: 0.8125rem" @click="addRow()">
                                                    <span class="btn-inner--icon"><i class="ni ni-fat-add"></i></span>
                                                    <span class="btn-inner--text">Tambah</span>
                                                </base-button>
                                            </div>
                                        </template>
                                        <template slot-scope="scope">
                                            <base-button v-if="true" size="sm" icon type="primary" class="mb-2" style="font-size: 0.8125rem" @click="delVal(scope)">
                                                <span class="btn-inner--icon"><i class="ni ni-paper-diploma"></i></span>
                                                <span class="btn-inner--text">delete</span>
                                            </base-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-4 variant="info"><b>STATUS ANJAKAN GAJI</b></b-button>
                </b-card-header>
                <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <b-card-text>
                            <h3 class="mb-0">STATUS ANJAKAN GAJI</h3>
                            <br />
                            <div class="pl-lg-4">
                                <b-card-header class="border-0">
                                    <h3 class="mb-0">TAHUN TIDAK MENERIMA PGT</h3>
                                </b-card-header>
                                <el-table class="table-responsive table" header-row-class-name="thead-light" :header-cell-style="{background:'#f6f9fc',color:'#8898aa'}" :data="this.objPaparAnjGaji" style="width: 100%">
                                    <el-table-column align="center" type="index" width="100px">
                                    </el-table-column>

                                    <el-table-column label="TAHUN KELULUSAN ANJAKAN GAJI" prop="YearID" min-width="200px" align="center">
                                    </el-table-column>

                                    <el-table-column label="GRED KELULUSAN ANJAKAN GAJI" prop="SalGrd" min-width="200px" align="center">
                                    </el-table-column>
                                </el-table>
                                <br /><br />
                                <b-button size="md" variant="primary" @click="ToPageAnjakan()">KEMASKINI MAKLUMAT</b-button>
                            </div>
                        </b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-5 variant="info"><b>STATUS KENAIKAN PANGKAT</b></b-button>
                </b-card-header>
                <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <b-card-text>

                            <!-- <b-card no-body> -->
                            <b-card-header class="border-0">
                                <h3 class="mb-0">MAKLUMAT KENAIKAN PANGKAT</h3>
                            </b-card-header>
                            <el-table class="table-responsive table" header-row-class-name="thead-light" :header-cell-style="{background:'#f6f9fc',color:'#8898aa'}" :data="objPaparKenaikanPangkat" style="width: 100%">
                                <el-table-column align="center" type="index" width="100px">
                                </el-table-column>

                                <el-table-column label="TARIKH KENAIKAN PANGKAT" prop="tblGJKenaiknPgkt" min-width="200px" align="center">
                                </el-table-column>

                                <el-table-column label="SKIM PERKHIDMATAN" prop="ServClassTitle" min-width="200px" align="center">
                                </el-table-column>

                                <el-table-column label="GRED KENAIKAN PANGKAT" prop="SalGrd" min-width="200px" align="center">
                                </el-table-column>
                            </el-table>
                            <br /><br />
                            <b-button size="md" variant="primary" @click="ToPageKenaikanPangkat()">KEMASKINI MAKLUMAT</b-button>
                            <!-- </b-card> -->

                        </b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-6 variant="info"><b>STATUS GAJI KUP BERMULA 2015</b></b-button>
                </b-card-header>
                <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <b-card-text>

                            <!-- <b-card no-body>
                                <b-card-header class="border-0">
                                    <h3 class="mb-0">STATUS GAJI KUP BERMULA 2015</h3>
                                </b-card-header> -->
                            <h3 class="mb-0">**Maklumat Hanya Diisi Untuk Pegawai Yang telah Diluluskan Gaji KUP Bermula Tahun 2015</h3>
                            <br />
                            <div class="pl-lg-4">

                                <b-row class="my-1">
                                    <b-col sm="3"> Tarikh Kuatkuasa Gaji KUP * </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="3">

                                        <base-input type="date" v-model="ObjKUP.DtGajiKUP" size="sm"></base-input>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col sm="1"></b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3">Amaun Gaji KUP Yang Diluluskan * </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="4">
                                        <b-form-input v-model="ObjKUP.SalKUP"></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-button size="md" variant="primary" @click="SimpanMaklumatKup()">KEMASKINI MAKLUMAT</b-button>

                            </div>

                        </b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-7 variant="info"><b>STATUS PENETAPAN GAJI PERMULAAN</b></b-button>
                </b-card-header>
                <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <b-card-text>

                            <h3 class="mb-0">**Maklumat Hanya Diisi Untuk Pegawai terlibat</h3>
                            <br />
                            <h3 class="mb-0">Penetapan Gaji Permulaan Gred 11, 13, 19 PPP1/2016</h3>
                            <br />
                            <br />
                            <div class="pl-lg-4">

                                <b-row class="my-1">
                                    <b-col sm="3">Amaun Gaji Permulaan pada 1 Julai 2016 * </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="4">
                                        <b-form-input v-model="ObjPenetepanGaji.Sal2016"></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-button size="md" variant="primary" @click="SimpanMaklPenetapan()">KEMASKINI MAKLUMAT</b-button>

                            </div>

                        </b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-8 variant="info"><b>STATUS TUKAR LANTIK PP01/2016</b></b-button>
                </b-card-header>
                <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <b-card-text>
                            <div v-if="activeMaklTukarLantik==1">
                                <b-row class="my-1">
                                    <b-col sm="3"> Tarikh Kuatkuasa Gaji KUP * </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="3">
                                        {{ObjTukarLantik.DtTukarLantik}}

                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col sm="1"></b-col>
                                </b-row>

                                <b-row>
                                    <b-col sm="3"> Klasifikasi Perkhidmatan Tukar Lantik * </b-col>
                                    <b-col sm="1"> :</b-col>
                                    <b-col sm="8">
                                        {{ObjTukarLantik.ServClassTitle}} 
                                    </b-col>
                                </b-row>

                                <br />
                                <b-row>
                                    <b-col sm="1"></b-col>
                                </b-row>

                                <b-row>
                                    <b-col sm="3"> Skim Tukar Lantik *</b-col>
                                    <b-col sm="1"> :</b-col>
                                    <b-col sm="8">
                                        {{ObjTukarLantik.SchmOfServTitle}}
                                    </b-col>
                                </b-row>

                                <br />
                                <b-row class="my-1">
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"> Gred Tukar Lantik * </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="3">
                                        {{ObjTukarLantik.SalGrd}}
                                    </b-col>
                                </b-row>

                                <br />
                                <b-row class="my-1">
                                    <b-col sm="3">Amaun Gaji Tukar Lantik * </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="4">
                                        {{ObjTukarLantik.SalTukarLantik}}
                                    </b-col>
                                </b-row>

                                <b-button size="md" variant="primary" @click="ToPageTukarLantik()">KEMASKINI MAKLUMAT</b-button>
                            </div>

                            <div v-if="this.activeMaklTukarLantik==0">
                                <!-- <b-container fluid class="mt--6">
                                    <card header-classes="bg-transparent"> -->
                                <!-- <h3 class="mb-0">STATUS MAKLUMAT PEGAWAI LANTIKAN SEBELUM 2003</h3> -->
                                <br />
                                <div class="pl-lg-4">
                                    <b-row class="my-1">
                                        <b-col sm="5"> TIADA MAKLUMAT </b-col>
                                    </b-row>
                                    <b-button size="md" variant="primary" @click="ToPageTukarLantik()">KEMASKINI MAKLUMAT</b-button>
                                </div>
                                <!-- </card>
                                </b-container> -->
                            </div>

                        </b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
            </div>
            <br/>
            <b-card>
            <b-button size="md" variant="primary" v-show="!active" @click="simpanMaklumatSemua()">SIMPAN MAKLUMAT</b-button>
            <b-button size="md" variant="success" v-show="active" @click="JanaGaji()">JANA KIRAAN GAJI</b-button>
            </b-card>

    </card>
    <!--Form modal-->
    <modal :show.sync="modals.addYear" body-classes="p-0">
        <template slot="header">
            <h3 class="mb-0">TAMBAH TAHUN</h3>
        </template>
        <template>
            <card>
                <validation-observer v-slot="{ invalid }">
                    <div class="pl-lg-4">
                        <validation-provider name="JENIS ADUAN" :rules="{ required: true }" v-slot="validationContext">
                            <b-row class="my-1">
                                <b-col sm="5">
                                    <label>Tahun Tidak Menerima PGT</label>
                                </b-col>
                                <b-col sm="5">
                                    <b-form-input id="YearID" v-model="obj.YearID"></b-form-input>
                                </b-col>
                                <!-- <b-col sm="5">
                        <b-button variant="default" @click="tambah">TAMBAH</b-button>
                    </b-col> -->
                            </b-row>
                        </validation-provider>
                        <b-row>
                            <b-col sm="12">
                                <b-button variant="success" type="submit" @click="tambah()" :disabled="invalid">SIMPAN</b-button>
                                <!-- <b-button size="md" variant="danger" @click="batal()">BATAL</b-button> -->
                            </b-col>
                        </b-row>

                    </div>
                </validation-observer>
            </card>
        </template>
        <template slot="footer"> &nbsp; </template>
    </modal>

</div>
</template>

<script>
import {
    Table,
    TableColumn,
    Pagination
} from "element-ui";
import Store from "@/store";
import moment from "moment";
import GetselenggaraService from "@/services/selenggaraService.js";
import swal from "sweetalert2";
import { log } from 'util';
export default {
    name: "light-table",
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,

    },
    data() {
        return {
            modals: {
                addYear: false,
                MDLMaklumatPeribadi: false,
            },
            obj: {

            },
            objthnTdkPGT: [],
            ServClassTukarLantikList: {},
            SchmTukarLantikList: {},
            SalGrdTukarLantikList: {},
            ServClassList: {},
            SchmOfServList: {},
            SalGrdList: {},
            StatusTiadaPGTview: 0,
            indPaparmaklumat: {
                indPaparmaklumat: 1
            },
            activeMakl2003: 0,
            objPaparAnjGaji: [],
            objPaparKenaikanPangkat: [],
            ObjKUP: {},
            ObjPenetepanGaji: {},
            ObjTukarLantik: {},
            activeMaklTukarLantik:0,
            active: false,
            

        }
    },
    methods: {

        addRow() {
            this.modals.addYear = true;
        },
        tambah() {
            //this.$emit("addItem", this.form);
            console.info("year id", this.obj)
            //this.$store.commit("clearMaklPegGaji");
            //this.objthnTdkPGT['YearID'] =this.YearID
            //this.obj.StatusTiadaPGT=this.selectedStatusTiadaPGT;
            this.objthnTdkPGT.push(this.obj);
            console.info("objthnTdkPGT id", this.objthnTdkPGT)
            this.$store.commit("addMaklPegGaji", this.objthnTdkPGT);
            this.modals.addYear = false;
            this.obj = [];

            swal
                .fire({
                    title: `Operasi Berjaya.`,
                    buttonsStyling: true,
                    icon: "success",
                })
        },
        delVal(scope) {
            //alert(scope.$index);

            this.objthnTdkPGT.splice(scope.$index, 1);

        },
        maklumatPeribadi() {
            this.NamaPeribadi = this.$store.state.MaklumatPeribadi.Nama;
            this.NoKP = this.$store.state.MaklumatPeribadi.NoKP;
            this.$store.state.MaklumatPeribadi.TarikhLantikan = moment(this.$store.state.MaklumatPeribadi.TarikhLantikan, "YYYY-MM-DD").format("DD-MM-YYYY");
            this.$store.state.MaklumatPeribadi.TarikhJangkaBersara = moment(this.$store.state.MaklumatPeribadi.TarikhJangkaBersara, "YYYY-MM-DD").format("DD-MM-YYYY");
            this.$store.state.MaklumatPeribadi.DtMeninggalDunia = moment(this.$store.state.MaklumatPeribadi.DtMeninggalDunia, "YYYY-MM-DD").format("DD-MM-YYYY");
            if (this.$store.state.MaklumatPeribadi.StatusKGT2023 == 1) {
                this.StatusKGT2023Papar = "Ya";
            } else {
                this.StatusKGT2023Papar = "Tidak";
            }
        },

        MaklPegSeb2003() {
            if (this.$store.state.MaklPegSeb2003.StatusLantikanSblm2003 == 1) {
                this.activeMakl2003 = 1
            }

            this.$store.state.MaklPegSeb2003.DtTPG2002 = moment(this.$store.state.MaklPegSeb2003.DtTPG2002, "YYYY-MM-DD").format("DD-MM-YYYY");

            //dapat klasfikasi skim
            let Search = {
                ServClassId: this.$store.state.MaklPegSeb2003.ServClassId,
            };
            console.log("search", this.Search)

            GetselenggaraService.getServClass(Search)
                .then((resp) => {
                    this.ServClassList = resp.data[0];
                    //console.log("SERVE",this.ServClassList);
                })
                .catch((err) => {
                    console.log(err);
                });

            this.ServClassList.ServClassTitle;

            let Search2 = {
                SchmOfServId: this.$store.state.MaklPegSeb2003.SchmOfServId,
            };

            GetselenggaraService.getSchmOfServ(Search2)
                .then((resp) => {
                    this.SchmOfServList = resp.data[0];
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });

            let Search3 = {
                SalGrdId: this.$store.state.MaklPegSeb2003.SalGrdID,
            };

            GetselenggaraService.getSalGrd(Search3)
                .then((resp) => {
                    this.SalGrdList = resp.data[0];
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });

        },
        MaklTukarLantik() {

            console.log("MaklTukarLantik", this.$store.state.MaklTukarLantik)

            if (this.$store.state.MaklTukarLantik.StatusTukarLantik==1) {
                this.activeMaklTukarLantik = 1
            }

            console.log("activeMaklTukarLantik", this.activeMaklTukarLantik)

            if (this.$store.state.MaklTukarLantik) {
                this.ObjTukarLantik = this.$store.state.MaklTukarLantik;
            }

            this.ObjTukarLantik.DtTukarLantik = moment(this.ObjTukarLantik.DtTukarLantik, "YYYY-MM-DD").format("DD-MM-YYYY");

            //dapat klasfikasi skim
            let Search3 = {
                ServClassId: this.ObjTukarLantik.ServClassId,
            };
            
            
            GetselenggaraService.getServClass(Search3)
                .then((resp) => {
                    this.ServClassTukarLantikList = resp.data[0];
                    // console.log("this",this)
                    //console.log("array this.ServClassList.ServClassTitle", this.ServClassTukarLantikList.ServClassTitle)
                    // this.ObjTukarLantik.ServClassTitle = this.ServClassTukarLantikList.ServClassTitle;
                    // console.log('----- >>>',this.ObjTukarLantik.ServClassTitle, this.ServClassTukarLantikList.ServClassTitle)
                    this.$set(this.ObjTukarLantik, 'ServClassTitle', this.ServClassTukarLantikList.ServClassTitle)
                })
                .catch((err) => {
                    console.log(err);
                });

            let Search2 = {
                SchmOfServId: this.ObjTukarLantik.SchmOfServId,
            };

            GetselenggaraService.getSchmOfServ(Search2)
                .then((resp) => {
                    this.SchmTukarLantikList = resp.data[0];
                    this.$set(this.ObjTukarLantik, 'SchmOfServTitle', this.SchmTukarLantikList.SchmOfServTitle)
                    //this.ObjTukarLantik.SchmOfServTitle = this.SchmTukarLantikList.SchmOfServTitle;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });

            let Search = {
                SalGrdId: this.ObjTukarLantik.SalGrdID,
            };

            GetselenggaraService.getSalGrd(Search)
                .then((resp) => {
                    this.SalGrdTukarLantikList = resp.data[0];
                    this.$set(this.ObjTukarLantik, 'SalGrd', this.SalGrdTukarLantikList.SalGrd)
                    //this.ObjTukarLantik.SalGrd = this.SalGrdTukarLantikList.SalGrd;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });

        },
        MaklPegGaji() {
            //console.log("array MaklPegGaji",this.$store.state.MaklPegGaji)
            // this.objPaparPerGaji=this.$store.state.MaklPegGaji;
        },
        ToPagePegGaji() {
            console.log("array ini", this.indPaparmaklumat)
            //this.$store.commit("IndpaparMaklPegGaji", this.indPaparmaklumat);

            this.$router.push({
                name: 'STATUS TIADA PERGERAKAN GAJI TAHUNAN',
            })
        },
        ToPageMaklumatperibadi() {
            this.$router.push({
                name: 'KEMASKINI MAKLUMAT PERIBADI',
            })
        },
        ToPageAnjakan() {
            this.$router.push({
                name: 'STATUS ANJAKAN GAJI',
            })
        },
        ToPageLantikan2003() {

            this.$router.push({
                name: 'STATUS MAKLUMAT PEGAWAI LANTIKAN SEBELUM 2003',
            })
        },
        ToPageKenaikanPangkat() {

            this.$router.push({
                name: 'STATUS KENAIKAN PANGKAT',
            })
        },
        ToPageTukarLantik() {

            this.$router.push({
                name: 'STATUS TUKAR LANTIK PP01/2016',
            })
        },
        MaklAnjGaji() {
            if (this.$store.state.MaklAnjGaji[0]) {
                this.objPaparAnjGaji = this.$store.state.MaklAnjGaji;
            }

        },
        MaklKenaikanPangkat() {
            if (this.$store.state.MaklKenaikanPangkat[0]) {
                this.objPaparKenaikanPangkat = this.$store.state.MaklKenaikanPangkat;
            }

        },
        SimpanMaklumatKup() {
            this.$store.commit("addMaklGajiKUP", this.ObjKUP);
            swal
                .fire({
                    title: `Operasi Berjaya.`,
                    buttonsStyling: true,
                    icon: "success",
                })
        },
        SimpanMaklPenetapan() {
            this.$store.commit("addMaklPentapGaji", this.ObjPenetepanGaji);
            swal
                .fire({
                    title: `Operasi Berjaya.`,
                    buttonsStyling: true,
                    icon: "success",
                })
        },
        simpanMaklumatSemua(){
            //this.$store.commit("addMaklPentapGaji", this.ObjPenetepanGaji);
            swal
                .fire({
                    title: `SIMPAN MAKLUMAT BERJAYA.`,
                    buttonsStyling: true,
                    icon: "success",
                })

                this.active = true;
        }
    },
    computed: {
        MaklumatPeribadiInStore() {
            return Store.state.MaklumatPeribadi;
            //console.log("ini store", Store.state.MaklumatPeribadi);
        },
        MaklPegSeb2003InStore() {
            return Store.state.MaklPegSeb2003;
        },
        MaklPegGajiInStore() {
            return Store.state.MaklPegGaji;
        },
        MaklAnjGajiInStore() {
            return Store.state.MaklAnjGaji;
        },
        MaklKenaikanPangkatInStore() {
            return Store.state.MaklKenaikanPangkat;
        },
        MaklGajiKUPInStore() {
            return Store.state.MaklGajiKUP;
        },
        MaklPentapGajiInStore() {
            return Store.state.MaklPentapGaji;
        },
        MaklTukarLantikInStore() {
            return Store.state.MaklTukarLantik;
        }

    },

    async created() {

        await this.maklumatPeribadi();
        await this.MaklPegSeb2003();
        await this.MaklPegGaji();
        await this.MaklAnjGaji();
        await this.MaklKenaikanPangkat();
        await this.MaklTukarLantik();

        console.log("state", this.$store.state)

        if (this.$store.state.MaklPegGaji) {
            this.objthnTdkPGT = this.$store.state.MaklPegGaji;
        }

        if (this.$store.state.MaklGajiKUP) {
            this.ObjKUP = this.$store.state.MaklGajiKUP;
        }

        if (this.$store.state.MaklPentapGaji) {
            this.ObjPenetepanGaji = this.$store.state.MaklPentapGaji;
        }



    }
}
</script>

<style scoped>
.btn.collapsed {
    text-align: left !important;

}
</style>
